export const ERROR_CODES_CONSTANTS = {
  EC001: "Invalid username/password",
  EC002: "Your account is blocked. Please contact Office Admin",
  EC003: "Your office currently blocked. Please contact super admin",
  EC004: "No office assigned to you. Please contact super admin",
  EC005: "kiosk is not in working state",
  EC006: "kiosk is not active.contact to office admin",
  EC007: "Already Exists!",
  EC008: "Username Is Valid !!!",
  EC009: "Mobile Number Already Exists!",
};
